import { EXCHANGE_RATES } from '~/utils/api-response/finance'
import { CURRENCY_LIST, LANGUAGES } from '~/utils/api-response/settings'

// State
export const state = () => ({
  language: [],
  isMobile: false,
  maintenance: {},
  supportCountry: [],
  exchangeRate: [],
  countries: [],
  displayRegisterModal: false,
  isInternational: true,
  exchangeRateLoading: false,
  exchangeRateByPlayerCurrency: {}
})

// Actions
export const actions = {
  // Get exchange rate
  getExchangeRate({ commit }) {
    const response = CURRENCY_LIST
    commit('setExchangeRate', response.data)
  },
  getExchangeRateByPlayerCurrency({ commit }, params) {
    const response = EXCHANGE_RATES
    commit('setExchangeRateByPlayerCurrency', response.data)
  },
  // Get support languages
  async getSupportCountry({ commit }) {},
  // Get languages
  getLanguage({ commit, rootState, dispatch }, currency) {
    const response = LANGUAGES
    const data = response.data
    // Fallback mechanism: If the locale was not successfully set via the default API
    // and there are available language options, set the default language from the data.
    if (!this.$cookie.get('wl_locale') && data?.length > 0) {
      const getDefaultLang = data.find(el => el.is_default)
      if (getDefaultLang) {
        dispatch('base-settings/updateLocaleAndSetCookie', getDefaultLang.language, {
          root: true
        })
      }
    }
    commit('setLanguage', data)
  },
  // Set visit website
  async fetchVisitWebsite({ state, dispatch }) {
    // Since Lao and international have different logic, it's better to separate the Actions
    if (state.isInternational) {
      await dispatch('fetchVisitForInternational')
      return
    }
    await dispatch('fetchVisitForLao')
  },
  fetchVisitForLao({ commit }) {},
  fetchVisitForInternational({ commit }) {},
  whiteLabel({ commit }) {
    const checkIfInternational = true
    commit('whiteLabel', checkIfInternational)
  }
}

// Mutations
export const mutations = {
  setLanguage(state, data) {
    state.language = data
  },
  setIsMobile(state, data) {
    state.isMobile = data
  },
  setMaintenance(state, val) {
    state.maintenance = val
  },
  setSupportCountry(state, val) {
    state.supportCountry = val
  },
  setExchangeRate(state, val) {
    state.exchangeRate = val
  },
  setCountries(state, val) {
    state.countries = val
  },
  setDisplayRegisterModal(state, val) {
    state.displayRegisterModal = val
  },
  whiteLabel(state, val) {
    state.isInternational = val
  },
  setExchangeRateLoading(state, val) {
    state.exchangeRateLoading = val
  },
  setExchangeRateByPlayerCurrency(state, val) {
    state.exchangeRateByPlayerCurrency = val
  }
}

// Getters
export const getters = {
  language: state => state.language.filter(lng => lng.is_active),
  maintenance: state => state.maintenance,
  supportCountry: state => state.supportCountry,
  exchangeRate: state => {
    const displayBothRateAndReveredRate = []
    if (state.exchangeRate?.length > 0) {
      state.exchangeRate.forEach(el => {
        // push default currency
        if (el.is_show_lnd) {
          displayBothRateAndReveredRate.push(el)
        }

        // Swap currency and rates with type 2 only.
        if (el.is_show_lnd_reverse) {
          const { rate, from_currency: fCurrency, reversed_rate: rRate } = el
          const swapEl = {
            ...el,
            from_currency: el.to_currency,
            to_currency: fCurrency,
            rate: rRate,
            reversed_rate: rate
          }
          displayBothRateAndReveredRate.push(swapEl)
        }
      })
    }
    return displayBothRateAndReveredRate
  },
  exchangeRatesWithCurrency: state => currency => {
    const displayBothRateAndReveredRate = []
    if (state.exchangeRate?.length > 0) {
      const data = JSON.parse(JSON.stringify(state.exchangeRate))
      const filteredFromCurrency = data.filter(el => el.from_currency === currency)
      filteredFromCurrency.forEach(el => {
        // push default currency
        if (el.is_show_lnd) {
          displayBothRateAndReveredRate.push(el)
        }

        // Swap currency and rates with type 2 only.
        if (el.is_show_lnd_reverse) {
          const { rate, from_currency: fCurrency, reversed_rate: rRate } = el
          const swapEl = {
            ...el,
            from_currency: el.to_currency,
            to_currency: fCurrency,
            rate: rRate,
            reversed_rate: rate
          }
          displayBothRateAndReveredRate.push(swapEl)
        }
      })
    }
    return displayBothRateAndReveredRate
  },
  swapAllExchangeRate: state => {
    const displayBothRateAndReveredRate = []
    if (state.exchangeRate?.length > 0) {
      state.exchangeRate.forEach(el => {
        displayBothRateAndReveredRate.push(el)
        const { rate, from_currency: fCurrency, reversed_rate: rRate } = el
        const swapEl = {
          ...el,
          from_currency: el.to_currency,
          to_currency: fCurrency,
          rate: rRate,
          reversed_rate: rate
        }
        displayBothRateAndReveredRate.push(swapEl)
      })
    }
    return displayBothRateAndReveredRate
  },
  countries: state => state.countries
}
